import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { UseI18n } from '../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import TextEllipsis from '../../../../../../common/textEllipsis'
import { Tooltip } from '../../../../../../common/tooltip'
import { formatVal } from '../../../../../../helpers/value'
import classes from '../../../index.module.scss'

const Chart = ({
  data,
  label,
  operator,
  chartId,
  valueCode,
  valueAvgCode,
  tooltipContent,
  isLastChart,
  isDynamicReport,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const avgText = UseI18n('financialAnalysis.AVG')

  const ratioNameById = {
    RT0009: 'DSO',
    RTI0009: 'DSO' + avgText,
    RT0011: 'DIO',
    RTI0011: 'DIO' + avgText,
    RT0013: 'DPO',
    RTI0013: 'DPO' + avgText,
    RT0015: 'CCC',
    RTI0015: 'CCC' + avgText,
  }

  return (
    <div className={classes.chartSmallContainer}>
      <div className={classes.titleChart}>
        <div className="dFlex w100 alignItemsCenter">
          {!isDynamicReport && (
            <Tooltip tooltipContent={tooltipContent}>
              <Icon
                className="icon-info-circle"
                style={{ color: '#9C9C9C', paddingRight: 3 }}
              />
            </Tooltip>
          )}
          <div className="w80">
            {isDynamicReport ? (
              <Translate value={label} />
            ) : (
              <TextEllipsis text={label} />
            )}
          </div>
        </div>
        <Element className="fw600" style={{ fontSize: 14 }}>
          {operator}
        </Element>
      </div>
      <div className="h100">
        <ChartContainer
          chartId={chartId}
          data={data}
          margin={{ left: 0, bottom: 0, right: 0 }}
          width="100%"
          height="100%"
          xAxis={[
            {
              dataKey: 'year',
              padding: { left: 15, right: 15 },
              tickMargin: 3,
              height: 18,
              type: 'category',
              tickFormatter: (year) => '‘' + (year + '')?.slice(2, 4),
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: ['value', 'valueAvg'],
              isLineChart: true,
            },
          ]}
          tooltip={{
            schema: {
              content: [
                {
                  dataKey: 'value',
                  label: ratioNameById[valueCode],
                  unit: I18n.t('financialAnalysis.DAYS'),
                  formatValue: (val) => formatVal(val, locale),
                },
                {
                  dataKey: 'valueAvg',
                  label: ratioNameById[valueAvgCode],
                  unit: I18n.t('financialAnalysis.DAYS'),
                  formatValue: (val) => formatVal(val, locale),
                },
              ],
            },
            position: isLastChart ? { x: 0 } : undefined,
          }}
        >
          <Line yAxisId="left" dataKey="value" stroke="#006AA6" />
          <Line yAxisId="left" dataKey="valueAvg" stroke="#FFCD60" />
        </ChartContainer>
      </div>
    </div>
  )
}

Chart.propTypes = {
  data: PropTypes.array,
}

export default Chart
